import React from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../layout/table";
import { search as getUsers } from "../../actions/users";
import { only as numbersOnly } from "../../utils/number";
import { phone } from "../../utils/string";

import ConditionalButton from "../../layout/conditional-button";
import { send as pageInfo, loading } from "../../actions/page";
import { withNavigation } from "../../utils/wrapper";

class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            search: "",
            order: "email",
            index: 0,
            direction: "DESC",
            data: [],
            pages: 0,
            archived: 0,
            converted: 0
        };
        this.props.loading(true);
    }

    componentDidMount = () => {
        setTimeout(async () => {
            await this.loadData();
        }, 30);
    }


    loadData = async () => {
        this.props.loading(true);
        
        let { page, size, order, direction, search } = this.state;

        const __data = await this.props.getUsers({ page, size, order, direction, search });
        let __count = 0;

        if (__data?.items?.length > 0)
            __count = Math.ceil(Number(__data.count) / Number(size));

        this.setState({
            ...this.state,
            data: __data.items,
            pages: __count
        });

        await this.props.pageInfo({ title: "Users", breadcrumb: `Users` });
        this.props.loading(false);

    }


    get headers() {        
        return [
            {
                header: "Name",
                sortable: true,
                source: "lastName",
                className: "text-muted text-small text-uppercase w-35",
                onFormat: this.onNameLinkFormat
            },
            {
                header: "Email",
                sortable: true,
                source: "email",
                className: "text-muted text-small text-uppercase w-25",
                onFormat: this.onLinkFormat
            },
            {
                header: "Phone",
                sortable: true,
                source: "phone",
                className: "text-muted text-small text-uppercase w-25",
                onFormat: this.onPhoneLinkFormat
            }
        ]
    }

    onNameLinkFormat = (e, row) => {
        if (!(row["lastName"] && row["firstName"])) return "";

        return this.onLinkFormat(`${row["lastName"]}, ${row["firstName"]}`, row)
    }

    onLinkFormat = (e, row) => {
        return `<a href="/dashboard/users/${row['uuid']}">${e}</a>`
    }

    onPhoneLinkFormat = (e, row) => {
        if (!e) return "";
        let __phone = numbersOnly(e);
        if (__phone == 1) return "";
        return `<a href="tel:+${__phone}">${phone(__phone)}</a>`
    }

    onColumnClick = (e) => {
        const __array = this.headers;
        const __index = __array.findIndex((item) => {
            return item.header === e.header && item.source === e.source;
        });

        this.setState({
            ...this.state,
            index: __index,
            direction: this.state.index === __index && this.state.direction === "DESC" ? "ASC" : "DESC",
            order: __array[__index].source,
            page: 0
        }, this.fetchData);

    }

    onSearch = (e) => {
        this.setState({
            ...this.state,
            search: e
        }, this.fetchData);
    }

    onSize = (e) => {
        this.setState({
            ...this.state,
            page: 0,
            size: Number(e)
        }, this.fetchData);
    }

    onPageChange = (e) => {
        this.setState({
            ...this.state,
            page: Number(e)
        }, this.fetchData);
    }

    onNewClick = (e) => {
        this.props.navigate("add");
    }

    onConvertedChange = (e) => {
        this.setState({
            ...this.state,
            converted: this.state.converted===1 ? 0 : 1
        }, this.fetchData);
    }

    onArchivedChange = (e) => {
        this.setState({
            ...this.state,
            archived: this.state.archived===1 ? 0 : 1
        }, this.fetchData);
    }

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Create new user" display enabled={true} onEnabledClick={this.onNewClick} icon="flash">New</ConditionalButton>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        sort={{ index: this.state.index, direction: this.state.direction }}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchable={false}
                        sizable={false}
                    />
                </Col>
            </>
        )
    }
}

Users.propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default withNavigation(connect(mapStateToProps, { getUsers, loading, pageInfo })(Users));